import { ActionReducerMap } from '@ngrx/store';
import { AuthenticationReducer } from '../store/reducers/authentication.reducer';
import { IAuthenticationState } from './authentication-contracts';

export const SECURITY_AUTHENTICATION_REDUCER: ActionReducerMap<IAuthenticationState> = {
    authentication: AuthenticationReducer
};
